// extracted by mini-css-extract-plugin
export var modal = "subscription-type-info-modal-module--modal--AvLMX";